module.exports = __webpack_public_path__ + "img/manage-submissions-icon.af20883f.svg";